import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Modifier")
const _hoisted_2 = ["innerHTML"]

import { request } from "@/domains/api/api";
import { computed, ref } from "@vue/reactivity";
import * as marked from "marked";
import * as DOMpurify from "dompurify";
import { useUser } from "@/domains/auth/user";
import { ABILITY_WRITE_NEWS } from "@/domains/cruds/users/users";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const renderedHtml = ref("");
request<string>("news", "get").then((markdown) => {
    renderedHtml.value = DOMpurify.sanitize(marked.parse(markdown));
});

const user = useUser().user;
const canEditNews = computed(() =>
    user.value?.abilities?.includes(ABILITY_WRITE_NEWS)
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(canEditNews))
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: { name: 'news.edit' },
          class: "btn btn-primary"
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      innerHTML: renderedHtml.value,
      class: "markdown-body"
    }, null, 8, _hoisted_2)
  ], 64))
}
}

})